import { createSlice } from '@reduxjs/toolkit';

export interface SelectedAccountingPeriodTypes {
  selectedAccountingPeriod: {
    periodName: string;
    accountingPeriodID: string;
  };
}

const initialState: SelectedAccountingPeriodTypes = {
  selectedAccountingPeriod: {
    periodName: '',
    accountingPeriodID: '',
  },
};

export const ACCGSelectedAccountingPeriodSlice = createSlice({
  name: 'selectedAccountingPeriod',
  initialState,
  reducers: {
    setSelectedAccountingPeriod: (state, action) => {
      state.selectedAccountingPeriod = action.payload;
    },
    removeSelectedAccountPeriod: () => initialState,
  },
});

export default ACCGSelectedAccountingPeriodSlice.reducer;

export const { setSelectedAccountingPeriod, removeSelectedAccountPeriod } =
  ACCGSelectedAccountingPeriodSlice.actions;
